import { useEffect } from "react";
import {
  Flex,
  Heading,
  Text,
  Button,
  Tooltip,
  Input,
  useToast,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import {
  primary,
  primaryAlt,
  textPrimary,
  textSecondary,
  white,
} from "../../../utils/colors";
import { updateTenantClinicNameAction } from "../../../actions/tenantActions";
import { useDispatch, useSelector } from "react-redux";
import { TENANT_UPDATE_CLINICNAME_RESET } from "../../../constants/tenantConstants";

const OnboardingStepOne = ({ clinicName, setClinicName, setStep, tenant }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const toast = useToast();

  // REDUX
  const tenantUpdateClinicName = useSelector(
    (state) => state.tenantUpdateClinicName
  );
  const {
    loading: loadingUpdateClinicName,
    error: errorUpdateClinicName,
    success: successUpdateClinicName,
  } = tenantUpdateClinicName;

  // ERROR
  const isClinicNameError = clinicName?.length < 3;

  // HANDLERS
  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent the default form submission via HTTP

    dispatch(updateTenantClinicNameAction(clinicName, tenant.slug));
  };

  // USE EFFECT
  useEffect(() => {
    if (successUpdateClinicName) {
      setStep(1);
      dispatch({ type: TENANT_UPDATE_CLINICNAME_RESET });
    } else if (errorUpdateClinicName) {
      toast({
        title: t("toasts.onboardingUpdateClinicNameError"),
        status: "error",
        duration: 9000,
        isClosable: true,
      });

      dispatch({ type: TENANT_UPDATE_CLINICNAME_RESET });
    }
  }, [successUpdateClinicName, errorUpdateClinicName]);

  // LOG
  // console.log("clinicName", clinicName);
  // console.log("isClinicNameError", isClinicNameError);
  // console.log("tenant in step one", tenant);

  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      maxW={["100%", "800px"]}
    >
      <form onSubmit={handleSubmit}>
        <Flex
          direction="column"
          align={["flex-start", "center"]}
          justify={["flex-start", "center"]}
          p={["0 1.5rem", "0 0rem"]}
          maxW={["100%", "800px"]}
        >
          <Heading
            fontSize={["2.5rem", "3rem"]}
            // fontWeight="600"
            textAlign={["left", "center"]}
            color={textPrimary}
            pointerEvents="none"
            lineHeight={["1.2", "initial"]}
          >
            {t("onboarding.hello")}
          </Heading>

          <Text
            pointerEvents="none"
            textAlign={["left", "center"]}
            fontSize="1.125rem"
            mt={4}
            fontWeight="500"
            // color={textPrimary}
            color={textSecondary}
            maxW={["100%", "80%"]}
          >
            {t("onboarding.helloText")}
          </Text>

          <Flex
            gap={[2, 4]}
            align={["flex-start", "center"]}
            justify="center"
            p="2rem 0 2rem"
            w={["100%", "80%"]}
            direction="column"
          >
            <Text
              fontSize="md"
              fontWeight="500"
              //   color={textSecondary}
              color={textPrimary}
              //   textTransform="uppercase"
            >
              {t("onboarding.enterClinicName")}
            </Text>
            <Input
              autoFocus
              size="lg"
              h={["3.5rem", "4rem"]}
              fontSize="lg"
              bg="white"
              fontWeight="500"
              borderRadius={["1.5rem", "10rem"]}
              onChange={(e) => setClinicName(e.target.value)}
              value={clinicName}
              placeholder=""
              textAlign="center"
              maxW="600px"
              _focus={{
                borderColor: primary,
                // boxShadow: "0 0 0 2px rgba(0, 0, 0, 0.1)",
                boxShadow: "none",
              }}
            />
          </Flex>

          <Flex align="center" justify="center" w="100%" gap={4}>
            <Tooltip
              label={t("onboarding.clinicNameError")}
              placement="top"
              p="0.25rem 1rem"
              borderRadius="1rem"
              fontSize="xs"
              isDisabled={!isClinicNameError}
            >
              <Button
                type="submit"
                h="3.5rem"
                size="lg"
                borderRadius="10rem"
                // onClick={next}
                onClick={handleSubmit}
                isLoading={loadingUpdateClinicName}
                bg={textPrimary}
                px="3rem"
                minW={["100%", "10rem"]}
                color={white}
                transition="all 0.3s ease"
                _hover={{
                  bg: primaryAlt,
                  color: white,
                }}
                isDisabled={isClinicNameError}

                // isDisabled={!isEmailValid || loading}
                // isLoading={loading}
              >
                {t("onboarding.continue")}
              </Button>
            </Tooltip>
          </Flex>
        </Flex>
      </form>
    </Flex>
  );
};

export default OnboardingStepOne;
